var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8555 8.14793C23.4389 7.7221 22.8222 7.5646 22.2472 7.73126L8.83887 11.6054C8.2322 11.7738 7.8022 12.2546 7.68637 12.8646C7.56803 13.4863 7.98137 14.2763 8.52137 14.6063L12.7139 17.1663C13.1439 17.4296 13.6989 17.3638 14.0547 17.0071L18.8555 12.2063C19.0972 11.9554 19.4972 11.9554 19.7388 12.2063C19.9805 12.4471 19.9805 12.8396 19.7388 13.0896L14.9297 17.8904C14.573 18.2471 14.5063 18.8004 14.7688 19.2313L17.3305 23.4396C17.6305 23.9388 18.1472 24.2229 18.7138 24.2229C18.7805 24.2229 18.8555 24.2229 18.9222 24.2138C19.5722 24.1313 20.0888 23.6888 20.2805 23.0638L24.2555 9.75626C24.4305 9.1896 24.2722 8.57293 23.8555 8.14793Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50956 20.0066C8.34956 20.0066 8.18956 19.9458 8.06789 19.8233C7.82372 19.5791 7.82372 19.1841 8.06789 18.94L9.20539 17.8016C9.44956 17.5583 9.84539 17.5583 10.0896 17.8016C10.3329 18.0458 10.3329 18.4416 10.0896 18.6858L8.95122 19.8233C8.82956 19.9458 8.66956 20.0066 8.50956 20.0066ZM11.6439 21.0003C11.4839 21.0003 11.3239 20.9395 11.2022 20.817C10.9581 20.5728 10.9581 20.1778 11.2022 19.9336L12.3397 18.7953C12.5839 18.552 12.9797 18.552 13.2239 18.7953C13.4672 19.0395 13.4672 19.4353 13.2239 19.6795L12.0856 20.817C11.9639 20.9395 11.8039 21.0003 11.6439 21.0003ZM11.8553 23.9736C11.977 24.0961 12.137 24.157 12.297 24.157C12.457 24.157 12.617 24.0961 12.7386 23.9736L13.877 22.8361C14.1203 22.592 14.1203 22.1961 13.877 21.952C13.6328 21.7086 13.237 21.7086 12.9928 21.952L11.8553 23.0903C11.6111 23.3345 11.6111 23.7295 11.8553 23.9736Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.3b205283dcd3a3eb5175bd8aaf1072b6.svg";
export { ForwardRef as ReactComponent };